import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/index.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js")